<template>
  <div class="row" v-if="purchases.total > 0 || section.id == 2">
    <div
      class="col-12 bg-lightgrey p-2 d-flex align-items-center justify-content-between"
    >
      <h3 class="mb-0 fa-sm text-dark-blue pl-2">{{ section.name }}</h3>
      <i
        class="fa fa-sync has-interaction px-2 text-moon-blue"
        aria-hidden="true"
        @click="getData"
      ></i>
    </div>
    <div class="col-12" v-loading="loading">
      <el-table
        :data="purchases.data"
        style="width: 100%"
        class="fa-sm purchase-table"
        @sort-change="handleSortChange"
      >
        <el-table-column align="center" prop="id" width="60px">
          <template slot-scope="scope">
            <el-tooltip
              v-if="pendingRefinanceInvoice(scope.row) == 1"
              class="box-item"
              effect="dark"
              content="Refinance invoice required"
              placement="bottom-start"
            >
              <i
                class="el-icon-warning text-warning fa-lg"
                aria-hidden="true"
              ></i>
            </el-tooltip>
            <i class="fa fa-check text-success" v-else aria-hidden="true"></i>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="id" label="Trade #" width="70px">
          <template slot-scope="scope">
            {{ scope.row.purchase.ref_id }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="business.name" label="Producer">
          <template slot-scope="scope">
            <a
              v-if="scope.row && scope.row.purchase.business"
              :href="`/businesses/${scope.row.purchase.business_id}`"
            >
              {{ scope.row.purchase.business.short_name }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="invoice_due_date"
          label="Days until expiry"
        >
          <template slot-scope="scope">
            {{ getDaysUntilExpiryMT(scope.row.purchase) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="purchase.reference_code"
          label="Reference"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="livestock_class.name"
          label="Stock"
          width="60px"
        >
          <template slot-scope="scope">
            {{ scope.row.purchase.livestock_class.name.substring(0, 1) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="" label="Contract Balance">
          <template slot="header" slot-scope="scope">
            Balance
            <el-tooltip content="Livestock + Mgmt Fee" placement="bottom">
              <i class="fas fa-info-circle"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{
              scope.row.purchase_contract_balance_to_date
                ? "$" +
                  $_toLocaleString(
                    scope.row.purchase_contract_balance_to_date
                      .contract_balance_inc_gst,
                    2,
                  )
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="invoice_due_date" label="Expiry">
          <template slot-scope="scope">
            {{
              scope.row.purchase.invoice_due_date
                ? moment(scope.row.purchase.invoice_due_date).format(
                    "DD.MM.YYYY",
                  )
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="purchase.term"
          label="Term"
          width="70px"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="settlement_date"
          label="Settlement Date"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.settlement_date">
              {{ moment(scope.row.settlement_date).format("DD.MM.YYYY") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="open_head"
          label="Action"
          width="100px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_type">
              {{ scope.row.invoice_type.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_type">
              <div :class="getCloseoutStatusMT(scope.row.status_id)">
                {{ scope.row.status_id == 1 ? "Pending" : "" }}
                {{ scope.row.status_id == 2 ? "Approved" : "" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="open_head"
          label="INV"
          width="60px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type_id == 1">
              <a
                v-if="pendingRefinanceInvoice(scope.row) == 1"
                href=""
                @click.prevent="showUploadMediaModal(scope.row)"
                class="has-interaction text-blue mr-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Upload Invoice"
              >
                <i class="fa fa-upload fa-lg" aria-hidden="true"></i>
              </a>
              <a
                v-else-if="pendingRefinanceInvoice(scope.row) != 0"
                :href="pendingRefinanceInvoice(scope.row)"
                class="has-interaction text-success mr-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Download Invoice"
              >
                <i class="far fa-download fa-lg"></i>
              </a>
              <span v-else>--</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="open_head"
          label="Sale"
          width="70px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.show_invoice === true">
              <a
                href="#"
                class="d-block"
                v-if="scope.row.sale"
                @click.prevent="openInvoice(scope.row.sale_id)"
              >
                {{ scope.row.sale.ref_id }}
              </a>
              <a
                href="#"
                class="d-block"
                v-if="scope.row.off_pic_sale"
                @click.prevent="openInvoice(scope.row.off_pic_sale_id)"
              >
                {{ scope.row.off_pic_sale.ref_id }}
              </a>
            </div>
            <div v-else-if="scope.row.sale || scope.row.off_pic_sale">
              <el-tooltip
                class="item"
                effect="dark"
                content="Generating Sale Invoice(s)"
                placement="bottom"
              >
                <i class="el-icon el-icon-loading font-20"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="col-12 py-3 d-flex justify-content-center justify-content-xl-end"
      v-if="purchases.total > perPage"
    >
      <el-pagination
        layout="prev, pager, next, total"
        :current-page.sync="currentPage"
        @current-change="getData()"
        @prev-click="handlePrev"
        @next-click="handleNext"
        prev-text="Prev"
        next-text="Next"
        :background="true"
        :page-size="perPage"
        :page-count="purchases.last_page"
        :total="purchases.total"
      />
    </div>

    <upload-media-modal
      v-if="uploadMediaModalShow"
      :collectionData="collectionData"
      @refresh="refresh"
      @close="
        uploadMediaModalShow = false;
        collectionData = null;
      "
    ></upload-media-modal>
  </div>
</template>

<script>
import Purchase from "../../../modelsPortal/Purchase";
import Sale from "../../../modelsPortal/Sale";
import CloseoutPurchase from "../../../modelsPortal/common/CloseoutPurchase.js";
import OttleyFormatter from "../../../../mixins/OttleyFormatter";
import PayoutCloseoutModal from "../../../../common/PayoutCloseoutModal.vue";
import RefinanceCloseoutModal from "../../../../common/RefinanceCloseoutModal.vue";
import UploadMediaModal from "../../../../common/UploadMediaModal.vue";
import MaxTerm from "../../../../mixins/MaxTerm";
export default {
  components: {
    PayoutCloseoutModal,
    RefinanceCloseoutModal,
    UploadMediaModal,
  },
  mixins: [OttleyFormatter, MaxTerm],
  props: {
    invoiceTypes: {
      type: Array,
    },
    filter: {
      type: Object,
    },
    section: {
      type: Object,
    },
  },

  data() {
    return {
      purchases: {},
      perPage: 20,
      currentPage: 1,
      loading: false,
      open: false,
      orderBy: null,
      uploadMediaModalShow: false,
      collectionData: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    openInvoice(saleId) {
      new Sale()
        .find(saleId)
        .then((result) => {
          let sale = result;
          if (sale.invoice_html_url) {
            window.open(sale.invoice_html_url);
          } else {
            this.$message({
              type: "warning",
              message: "We are unable to open this link. Please try later",
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    downloadDocument(collection) {
      let media = collection;
      if (media) {
        var anchor = document.createElement("a");
        anchor.href = media.url;
        anchor.target = "_blank";
        anchor.download = media.file_name;
        anchor.click();
      }
    },
    invoiceAction(command, closeout) {
      if (command == "trade-inv") {
        let link = closeout.purchase.invoice_collections[0];
        this.downloadDocument(link);
      }
      if (command == "upload-closeout-inv") {
        this.showUploadMediaModal(closeout);
      }
      if (command == "download-closeout-inv") {
        let link = this.pendingRefinanceInvoice(closeout);
        this.downloadDocument(link);
      }
    },
    showUploadMediaModal(closeout) {
      let purchase = closeout.child_purchase;
      this.collectionData = {
        model_type: "purchase",
        model_id: purchase.id,
        collection_name: "invoice",
        media_collection_id: 6,
      };
      this.uploadMediaModalShow = true;
    },
    pendingRefinanceInvoice(closeout) {
      if (closeout.type_id == 1) {
        if (
          closeout.child_purchase &&
          closeout.child_purchase.invoice_collections.length > 0
        ) {
          return closeout.child_purchase.invoice_collections[0].download_url;
        }
        return 1;
      }
      return 0;
    },
    refresh() {
      this.collectionData = null;
      this.getData();
      this.$emit("refresh");
    },
    handleSortChange(column) {
      if (column.order == "ascending") {
        this.orderBy = "";
      } else if (column.order == "descending") {
        this.orderBy = "-";
      } else {
        this.orderBy = "";
      }
      this.orderBy = this.orderBy + column.prop;
      this.getData();
    },
    async getData() {
      this.loading = true;

      let purchases = new CloseoutPurchase()
        .select({
          "purchase.business": ["id", "name", "short_name"],
          purchase: [
            "id",
            "ref_id",
            "reference_code",
            "invoice_due_date",
            "invoice_invoice_date",
            "business_id",
            "livestock_class_id",
            "term",
          ],
          "purchase.livestockClass": ["id", "name"],
          closeoutPurchases: [
            "id",
            "type_id",
            "purchase_id",
            "status_id",
            "user_id",
            "settlement_date",
            "child_purchase_id",
            "sale_id",
            "off_pic_sale_id",
          ],
          childPurchase: ["id"],
          sale: ["id", "ref_id"],
          offPicSale: ["id", "ref_id"],
        })
        .append("purchase_contract_balance_to_date")
        .include(
          "purchase.business",
          "purchase.livestockClass",
          "invoiceType",
          "childPurchase.invoiceCollections",
          "sale",
          "offPicSale",
          "purchase.invoiceCollections",
        );

      if (this.orderBy) {
        purchases.orderBy(this.orderBy);
      } else {
        purchases.orderBy("-id");
      }

      if (this.filter.query) {
        purchases.where("where_like", this.filter.query);
      }

      if (this.filter.business_ids) {
        purchases.whereIn("purchase.business_id", this.filter.business_ids);
      }
      if (this.filter.expiry_id) {
        purchases.where("purchase.expiry_date_filter", this.filter.expiry_id);
      }

      if (this.filter.dof) {
        purchases.whereIn("purchase.days_of_feed_filter", this.filter.dof);
      }
      if (this.filter.direction_id) {
        purchases.where("type_id", this.filter.direction_id);
      }

      purchases.where("is_pending_or_not_close", true);

      purchases.page(this.currentPage).params({ per_page: this.perPage });

      await purchases
        .get()
        .then((res) => {
          this.purchases = res;
          this.purchases.data.forEach((c, i) => {
            let date = moment
              .utc(c.created_at, "YYYY-MM-DD HH:mm:ss")
              .local()
              .add(1, "minutes");
            c.show_invoice = moment().isBefore(date) ? false : true;
            this.$set(this.purchases.data, i, c);
          });
          let hiddenInvoices = this.purchases.data.filter(
            (p) => p.show_invoice == false,
          ).length;
          if (hiddenInvoices > 0) {
            setTimeout(() => {
              this.purchases.data = this.purchases.data.map((p) => ({
                ...p,
                show_invoice: true,
              }));
            }, 30000);
          }
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    handleNext() {
      this.currentPage++;
    },
    handlePrev() {
      this.currentPage > 1 && this.currentPage--;
    },
  },
};
</script>
